import axios, { AxiosResponse } from 'axios';
//import { param } from 'jquery';
import { con } from '../../../application/entity/Rutas';
import { IServiceResult } from '../../Interfaces/IServiceResult';
import { ServiceResult } from './ServiceResult';

export class SVCPacPat {

    public static async IniciarMandatoPat(rut: number, codigoNegocio: number, codigoPrograma: string, codigoPlanificacionAcademica: number, agnoProceso: number): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "GeneracionMandatoPat/iniciarMandatoPat";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";

        await axios
            .post(url, {
                "rut": rut,
                "codigoNegocio": codigoNegocio,
                "codigoPrograma": codigoPrograma,
                "codigoPlanificacionAcademica": codigoPlanificacionAcademica,
                "agnoProceso": agnoProceso
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async ValidarMandatoPat(token: string, rutAlumno: number, codPrograma: string): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "GeneracionMandatoPat/validarMandatoPat";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        let data: any[] = [];
        await axios
            .post(url, data, {
                params: {
                    "token": token,
                    "rutAlumno": rutAlumno,
                    "codCarrera": codPrograma
                }
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async ObtenerBancosGPA(): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "Banco/getBancoGPA";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        await axios
            .get(url)
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async IniciarMandatoPac(data: any): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "GeneracionMandatoPac/iniciarMandatoPac";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";

        await axios
            .post(url, data)
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async InsertarMandatoPat(data: any): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "GeneracionMandatoPat/insertarMandatoPat";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";

        await axios
            .post(url, data)
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async TieneMandatoPac(codCarrera: string, rutAlumno: number, tipoMandato: number, tipoOrigen: number): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "GeneracionMandatoPac/tieneMandatoPac";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        let data: any[] = [];
        await axios
            .post(url, data, {
                params: {
                    "codCarrera": codCarrera,
                    "rutAlumno": rutAlumno,
                    "tipoMandato": tipoMandato,
                    "tipoOrigen": tipoOrigen
                }
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async TieneMandatoPat(codCarrera: string, rutAlumno: number, tipoMandato: number, tipoOrigen: number): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "GeneracionMandatoPat/tieneMandatoPat";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        let data: any[] = [];
        await axios
            .post(url, data, {
                params: {
                    "codCarrera": codCarrera,
                    "rutAlumno": rutAlumno,
                    "tipoMandato": tipoMandato,
                    "tipoOrigen": tipoOrigen
                }
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async ObtenerDatosAlumno(rut: number, codCarrera: string, esFormularioPAC: boolean): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "GeneracionMandatoPac/datosAlumno";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        let data: any[] = [];
        await axios
            .post(url, data, {
                params: {
                    "rut": rut,
                    "codCarrera": codCarrera,
                    "esFormularioPAC": esFormularioPAC
                }
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static obtenerReader = async (r: any) => {
        /* console.log(r.data) */
        const reader = await r.data.getReader();
        let by: any = [];
        while (true) {
            const { done, value } = await reader.read();

            if (value !== undefined) {
                console.log(`Received ${value.length} bytes`);
                by.push(value);
            }

            if (done) {
                break;
            }
        }
        return by;
    }

    public static async ObtieneComprobante(codCarrera: string, rutAlumno: number, tipoMandato: number, tipoOrigen: number): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "GeneracionMandatoPac/obtenerComprobante?codCarrera=" + codCarrera + "&rutAlumno=" + rutAlumno + "&tipoMandato=" + tipoMandato + "&tipoOrigen=" + tipoOrigen;
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        //let data: any[] = [];

        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/pdf',
            }
        }).then((response) => response.blob())
            .then((blob) => {
                const url = window.URL.createObjectURL(new Blob([blob]),);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute(
                    'download',
                    `comprobanteMandato.pdf`
                );

                document.body.appendChild(link);

                link.click()
            })
        return sr;
    }
}